/** The prototype's dialogs have no line under the header (the shell draws one by default). */
export const NO_HEADER_LINE = '[&>div:first-child]:border-b-0';

/** Wide dialog: 90% of the screen on a phone, 70% (up to 900px) from `md`. */
export const WIDE_MODAL = 'max-w-[90vw] md:max-w-[min(70vw,900px)]';

/**
 * Centered confirm, like the prototype's: icon, title and text in the middle, close button in the
 * corner and no lines. The shell's header is restyled instead of replaced, so the title stays the
 * one heading that names the dialog.
 */
export const CENTERED_PANEL = [
  'relative',
  '[&>div:first-child]:flex-col [&>div:first-child]:items-center [&>div:first-child]:border-b-0',
  '[&>div:first-child]:px-6 [&>div:first-child]:pb-2 [&>div:first-child]:pt-8',
  '[&>div:first-child>div:first-child]:flex-col [&>div:first-child>div:first-child]:text-center',
  '[&>div:first-child>div:last-child]:absolute [&>div:first-child>div:last-child]:right-4 [&>div:first-child>div:last-child]:top-4',
].join(' ');
